import { useTranslation } from 'react-i18next';
import { Line } from '@ant-design/plots';
import IconNoData from '../../../assets/Images/icons/icon-no-data';
import { Spin } from 'antd';
import { memo, useMemo } from 'react';

const ChartConsent = memo(function ChartConsent({ graphResponses, isLoading }) {
    const { t } = useTranslation();

    const config = useMemo(() => {
        return {
            data: graphResponses.graph,
            xField: 'date',
            yField: 'value',
            seriesField: 'type',
            smooth: true,
            color: ({ type }) => {
                if (type === 'Accepted') {
                    return '#2CD9C5';
                }

                return '#F0536F';
            },
            style: {
                cursor: 'pointer',
            },
            lineStyle: {
                lineWidth: 3,
            },
            legend: {
                layout: 'horizontal',
                marker: {
                    symbol: 'circle',
                },
            },
            state: {
                active: {
                    animate: { duration: 100, easing: 'easeLinear' },
                    style: {
                        cursor: 'pointer',
                        lineWidth: 2,
                        stroke: '#000',
                    },
                },
            },
            xAxis: {
                label: {
                    autoRotate: true,
                    style: {
                        cursor: 'pointer',
                        fill: '#505D6F',
                        fontWeight: 600,
                        fontSize: 12,
                    },
                },
            },
            yAxis: {
                label: {
                    autoRotate: true,
                    style: {
                        cursor: 'pointer',
                        fill: '#505D6F',
                        fontWeight: 600,
                        fontSize: 12,
                    },
                },
            },
            tooltip: {
                customContent: (title, data) => {
                    return (
                        <div className="p-3 text-xs font-semibold">
                            <div className="py-1 flex space-x-4">
                                {`${title} ${graphResponses.dateLabel}`}
                            </div>
                            {data?.map((item, index) => (
                                <div
                                    key={index}
                                    className="py-1 flex space-x-4"
                                >
                                    <svg
                                        width="12"
                                        height="13"
                                        viewBox="0 0 12 13"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="6"
                                            cy="6.5"
                                            r="6"
                                            fill={item.color}
                                        />
                                    </svg>
                                    <div>{t(item.data.type)}</div>
                                    <div>{item.data.value}</div>
                                </div>
                            ))}
                        </div>
                    );
                },
            },
        };
    }, [graphResponses, t]);

    return (
        <Spin spinning={isLoading}>
            <div className="bg-white p-6 rounded-lg h-full">
                <div className="text-lg font-semibold mb-4">
                    {t('Consent Ratio in')} {graphResponses.dateLabel}
                </div>
                {graphResponses.graph?.length <= 0 ? (
                    <div className="text-center text-sm space-y-2 my-32">
                        <IconNoData />
                        <p className="text-[#65707A] text-[14px]">
                            {t('common.noData')}
                        </p>
                    </div>
                ) : (
                    <Line {...config} />
                )}
            </div>
        </Spin>
    );
});

export default ChartConsent;
